import React from 'react';

export function CustomersSection({ customers = [], label }) {
  return (
    <div>
      {label && <div className="nx-clients-label">{label}</div>}
      <div className="nx-customers-grid">
        {customers.map((logo, i) => (
          <div key={i} className="nx-customers-logo nx-cust-item" style={{ '--nx-i': i }}>
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              style={{ height: logo.height || 48, width: 'auto', objectFit: 'contain', maxWidth: '100%' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
